import { render, staticRenderFns } from "./DashboardPatient.vue?vue&type=template&id=930026e2&scoped=true&"
import script from "./DashboardPatient.vue?vue&type=script&lang=js&"
export * from "./DashboardPatient.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "930026e2",
  null
  
)

export default component.exports